//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.ItemDefinition.js";
let d=[[],[[["nChildren"],"GetSingleDeviceChildren",{R_:{childrenOfDevice:"Routing.SingleDevice[]"}},0,0],[["replacementChildren"],"ReplaceSingleDeviceChildren",{},1,0],[["device"],"AddSingleDeviceChild",{},1,0],[["device"],"RemoveSingleDeviceChild",{},1,0],[["device"],"IsSingleDeviceChild",{R_:{value:''}},1,0],[[],"GetReferencingDevice",{R_:{device:"Routing.SingleDevice"}},0,0]],[]];
SPLM.Routing.AssemblyDefinition = class extends SPLM.Routing.ItemDefinition{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.AssemblyDefinition";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;